export const PAYMENT_PURPOSE_OPTIONS = [
  { label: "Tuition Fees", value: "SCHOOL_FEES" },
  { label: "Transport Fees", value: "TRANSPORT_FEES" },
  { label: "BOT Clearance", value: "BOT_CLEARANCE" },
  { label: "Custom Fee", value: "CUSTOM_FEE" },
  { label: "Admission Fees", value: "ADMISSION_FEES" },
];

const PURPOSE_LABELS = {
  SCHOOL_FEES: "Tuition Fees",
  "SCHOOL FEES": "Tuition Fees",
  "SCHOOL FEES PAYMENT": "Tuition Fees",
  "TUITION FEES": "Tuition Fees",
  TRANSPORT_FEES: "Transport Fees",
  "TRANSPORT FEES": "Transport Fees",
  "TRANSPORT FEES PAYMENT": "Transport Fees",
  BOT_CLEARANCE: "BOT Clearance",
  "BOT CLEARANCE": "BOT Clearance",
  "BEGINNING OF TERM CLEARANCE": "BOT Clearance",
  "BEGINNING OF TERM CLEARANCE PAYMENT": "BOT Clearance",
  CUSTOM_FEE: "Custom Fee",
  "CUSTOM FEE": "Custom Fee",
  "CUSTOM FEE PAYMENT": "Custom Fee",
  ADMISSION_FEES: "Admission Fees",
  "ADMISSION FEES": "Admission Fees",
  "ADMISSION FEES PAYMENT": "Admission Fees",
};

const getKnownPurposeLabel = (purpose) => {
  if (!purpose) return null;
  return PURPOSE_LABELS[String(purpose).trim().toUpperCase()] || null;
};

export const getPaymentPurposeLabel = (purpose, paymentPurpose) => {
  const knownLabel =
    getKnownPurposeLabel(paymentPurpose) || getKnownPurposeLabel(purpose);

  if (knownLabel) return knownLabel;
  if (!purpose) return "Unknown";

  return (
    String(purpose)
      .replace(/\s+payment\s*$/i, "")
      .trim() || "Unknown"
  );
};
